// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: 外見動画の名称・ボイス変更
const AdminOpsAppearanceUpdateApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_appearance_update";

    const ExecAdminOpsAppearanceUpdateApi = async (tAppearanceId, name, tVoiceTypeId) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { t_appearance_id: tAppearanceId, name: name, t_voice_type_id: tVoiceTypeId } });
    };

    return ExecAdminOpsAppearanceUpdateApi;
};

export default AdminOpsAppearanceUpdateApi;
